module.exports = __webpack_public_path__ + "static/media/img193.376c525f.jpg";